import { render, staticRenderFns } from "./addFriendImport.vue?vue&type=template&id=2514bb4b&scoped=true"
import script from "./addFriendImport.vue?vue&type=script&lang=js"
export * from "./addFriendImport.vue?vue&type=script&lang=js"
import style0 from "./addFriendImport.vue?vue&type=style&index=0&id=2514bb4b&prod&lang=less"
import style1 from "./addFriendImport.vue?vue&type=style&index=1&id=2514bb4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514bb4b",
  null
  
)

export default component.exports